import { render, staticRenderFns } from "./CartMobile.vue?vue&type=template&id=63ecd45a&"
import script from "./CartMobile.vue?vue&type=script&lang=js&"
export * from "./CartMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomSheet } from 'vuetify/lib/components/VBottomSheet';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBottomSheet,VDialog})
